export enum EBrowserFamily {
	IE = 'IE',
	CHROME = 'Chrome',
	SAFARI = 'Safari',
	FIREFOX = 'Firefox',
}